/* ANNUBIS — finalizar pedido por WhatsApp en lugar del checkout nativo de Shopify */
(function () {
  var WHATSAPP_NUMBER = '595983663795';
  var IVA_RATE = 0.11;

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return 'Gs. ' + amount.toLocaleString('es-PY');
  }

  function buildMessage(cart, wantsInvoice) {
    var lines = [];
    lines.push('Hola! Quiero hacer este pedido en ANNUBIS:');
    lines.push('');

    cart.items.forEach(function (item, index) {
      var detail = index + 1 + ') ' + item.product_title;
      if (item.variant_title) {
        detail += ' — ' + item.variant_title;
      }
      lines.push(detail);
      lines.push('   Cantidad: ' + item.quantity + ' x ' + formatMoney(item.price) + ' = ' + formatMoney(item.line_price));
    });

    lines.push('');
    lines.push('Subtotal: ' + formatMoney(cart.total_price));

    if (wantsInvoice) {
      var ivaAmount = Math.round(cart.total_price * IVA_RATE);
      var total = cart.total_price + ivaAmount;
      lines.push('Con factura (+11% IVA): ' + formatMoney(ivaAmount));
      lines.push('Total: ' + formatMoney(total));
    } else {
      lines.push('Sin factura');
      lines.push('Total: ' + formatMoney(cart.total_price));
    }

    lines.push('');
    lines.push('(Envío a coordinar)');

    return lines.join('\n');
  }

  function sendToWhatsapp(wantsInvoice) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        var message = buildMessage(cart, wantsInvoice);
        var url = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(message);
        window.location.href = url;
      });
  }

  function updateDisplayedTotal(root) {
    var checkbox = root.querySelector('[data-an-invoice-checkbox]');
    var totalEl = root.querySelector('[data-an-whatsapp-total]');
    var subtotalCents = parseInt(root.getAttribute('data-an-subtotal-cents'), 10) || 0;
    if (!checkbox || !totalEl) return;

    function render() {
      var total = subtotalCents;
      if (checkbox.checked) {
        total = subtotalCents + Math.round(subtotalCents * IVA_RATE);
      }
      totalEl.textContent = formatMoney(total);
    }

    checkbox.addEventListener('change', render);
    render();
  }

  function initCheckoutButton(button) {
    if (!button || button.dataset.anWhatsappBound) return;
    button.dataset.anWhatsappBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var wrapper = button.closest('[data-an-whatsapp-checkout]');
      var checkbox = wrapper ? wrapper.querySelector('[data-an-invoice-checkbox]') : null;
      sendToWhatsapp(checkbox ? checkbox.checked : false);
    });
  }

  function init() {
    document.querySelectorAll('[data-an-whatsapp-checkout]').forEach(updateDisplayedTotal);
    initCheckoutButton(document.getElementById('checkout'));
    initCheckoutButton(document.getElementById('CartDrawer-Checkout'));
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, init);
  }
})();
